import { FulfillmentType } from '../../../../Enums/fulfillment_type.enum.js';

var getFulfillmentTranslation = function (fulfillmentType, t) {
    switch (fulfillmentType) {
        case FulfillmentType.delivery:
            return {
                upperText: t('orderHistory.deliveringTo'),
                lowerText: t('checkout.changeAddress')
            };
        case FulfillmentType.pickup:
            return {
                upperText: t('header.pickupFrom'),
                lowerText: t('checkout.changeAddress')
            };
        default:
            return;
    }
};
var getStorePopupLabels = function (t) { return ({
    title: t('Choose your preferred store'),
    subtitle: function (count) { return "".concat(count, " ").concat(t('stores near you')); }
}); };

export { getFulfillmentTranslation, getStorePopupLabels };
//# sourceMappingURL=translations.js.map
